import * as React from 'react';

import Layout from '../Layout/Layout';

export default function Dashboard(){

  return <>
  <Layout><h1>Hello</h1></Layout>
  </>
}